import { makeAutoObservable } from "mobx";
import TrailExaustedModal from '@/components/modal/trial-exhausted';
import { HelperCore } from '@/common/helper';
import { ModifyImageStore } from "../store";
import MarketingStore from '@/store/marketing';
import { message } from "antd";
import userStore from '@/store/user';
import membershipStore from '@/components/membership/store';
import appLogger from '@public/log/monitor';
import { request } from "@/common";

class Store {
  imgUrl = '';
  isSubmitting = false;
  isLoading = false

  constructor() {
    makeAutoObservable(this);
  }

  setImgUrl = (url: string) => {
    this.imgUrl = url;
  }

  setIsLoading = (bool) => {
    this.isLoading = bool;
  }

  submit = () => {
    appLogger.log({
      key: 'aibot_photo_edit',
      action: 'click',
      arrt: 'cutout',
      type: 'generate',
    });
    this.setIsLoading(true);
    const req_params = {
      action: 'obj-extract',
      'obj-extract': JSON.stringify({ image_urls: [this.imgUrl] })
    };
    if (MarketingStore.isMarketingCloud) {
      req_params['biz_key'] = '360mkt';
    }
    request.post('/img_edit/submit?appsource=so&device_platform=Web', req_params).then((res) => {
      appLogger.log({
        key: 'aibot_photo_edit',
        action: 'act',
        arrt: 'cutout',
        type: 'photo_edit_succ',
        task_id: res.data.mid,
      });
      appLogger.log({
        key: 'aibot_photo_edit',
        action: 'act',
        arrt: 'cutout',
        type: 'rights_verify_succ',
        ext4: '',
      });
      this.setIsLoading(false);
      const id = res.data.task_id_str;
      const newTask = {
        id_str: id,
        status: 1, // 进行中
        // 其他必要属性
        data: JSON.stringify({ req_params: JSON.stringify(req_params) }),
      };
      // 更新用户余额
      userStore.getCoinBalance(); 
      ModifyImageStore.addNewTask(newTask);
      ModifyImageStore.setHistoryActiveTask('matting', id);
    }, (err) => {
      this.setIsLoading(false);
      if ([301039, 316000].includes(err.code)) {
          appLogger.log({
            key: 'aibot_photo_edit',
            action: 'act',
            arrt: 'cutout',
            type: 'rights_verify_fail',
            member_fail_reason: err.code === 301039 ? 'open_member' : 'no_balance',
            member_fail_function: err?.data?.feature_id?.split('_').join(','),
          });
          if (HelperCore.isMac()) {
            TrailExaustedModal.show({
              isMember: err.code === 301039,
              nanoCostLack: err.code === 316000,
            });
          } else {
              membershipStore.setData({
              show: true,
              checkstandType:
                err.code === 301039 ? 'openMembership' : 'namiRecharge',
              feature: err.data.feature_id,
              position: 'aibot_photo_edit',
            });
            if (err.code === 316000) {
              message.error('纳米余额不足，请充值');
            }
          }
      } else {
        if (`${err.code}` === '100003') {
          TrailExaustedModal.show({});
        }
        message.error(err.msg);
          appLogger.log({
          key: 'aibot_photo_edit',
          action: 'act',
          arrt: 'cutout',
          type: 'photo_edit_fail',
          ext1: `${err.code}` === '100003' ? 'nocash' : 'sys_fail',
          ext2: err.msg,
        });
      }
    });
  }

}

export default new Store();
